import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { EpicShowPlayerModule } from '@epicuro-next/features/lists/epic-show-player';

import { DynamicElementsListMediaComponent } from './components/dynamic-elements-list-media/dynamic-elements-list-media.component';

@NgModule({
  imports: [CommonModule, MediaPreviewModule, EpicShowPlayerModule],
  declarations: [DynamicElementsListMediaComponent],
})
export class DynamicElementsListMediaModule {}

DontTreeShake(DynamicElementsListMediaComponent);
